import { ROOM_CODE_ALPHABET, ROOM_CODE_LENGTH } from "@numbet/protocol";
import { useState, type FormEvent } from "react";
import { Footer, Page, SiteHeader } from "../components/ui.tsx";
import { NumberLine } from "../game/NumberLine.tsx";
import { t } from "../i18n.ts";
import { linkHandler, navigate } from "../router.ts";

const codePattern = new RegExp(`[^${ROOM_CODE_ALPHABET}]`, "g");
const EDGES = ["edge-pink tilt-l", "edge-cyan", "edge-yellow tilt-r"];
const PILLS = ["pill-pink", "pill-cyan", "pill-yellow"];

/** Beispiel-Hinweise wie im Entwurf 4a */
export function DemoHints({ hints }: { hints: readonly string[] }) {
  return (
    <div className="demo-hints">
      {hints.map((hint, i) => (
        <div key={i} className={`hint-card ${EDGES[i]}`}>
          <span className={`pill ${PILLS[i]}`}>{i + 1}/3</span>
          <div className="hint-text">{hint}</div>
        </div>
      ))}
    </div>
  );
}

export function Home() {
  const [code, setCode] = useState("");

  const onJoin = (e: FormEvent) => {
    e.preventDefault();
    if (code.length === ROOM_CODE_LENGTH) navigate(`/beitreten?code=${code}`);
    else navigate("/beitreten");
  };

  return (
    <>
      <SiteHeader />
      <Page>
        <section className="landing">
          <h1 className="hero-title">{t.heroTitle}</h1>
          <p className="hero-sub">{t.heroSub}</p>

          <div className="demo" aria-hidden="true">
            <div style={{ textAlign: "center" }}>
              <span className="question-banner">{t.demoQuestion}</span>
            </div>
            <DemoHints hints={t.demoHints} />
            <div className="panel" style={{ marginTop: 22, padding: "14px 10px" }}>
              <NumberLine
                answer={2962}
                unit="Meter"
                decimals={0}
                entries={[
                  { id: "cem", name: "Cem", estimate: 2800, winner: false },
                  { id: "ben", name: "Ben", estimate: 3100, winner: true },
                ]}
              />
            </div>
          </div>

          <div className="cta-row">
            <a className="btn btn-primary btn-large" href="/neu" onClick={linkHandler("/neu")}>
              {t.createRoom}
            </a>
            <span className="or muted">{t.or}</span>
            <form onSubmit={onJoin}>
              <label className="visually-hidden" htmlFor="code">
                {t.roomCode}
              </label>
              <input
                id="code"
                className="input"
                value={code}
                autoCapitalize="characters"
                autoComplete="off"
                maxLength={ROOM_CODE_LENGTH}
                placeholder={t.roomCodePlaceholder}
                onChange={(e) => setCode(e.target.value.toUpperCase().replace(codePattern, ""))}
              />
              <button className="btn btn-cyan">{t.join}</button>
            </form>
          </div>
        </section>
      </Page>
      <Footer />
    </>
  );
}
